<template>
    <div class="HybridInput" :class="computedClass">
        <DefaultInputField
            class="input-field"
            :placeholder="placeholder"
            :type="type" 
            :value="value"
            :validator="validator"
            :pattern="pattern"
            :invalid="invalid"
            :title="title"
            @input="$emit('input', $event)"
            />
        <div class="readonly-value">{{ value || placeholder }}</div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons';
    import DefaultInputField from '@/components/input/DefaultInputField.vue';

    library.add(faPen, faTimes);

    export default {
        name: 'HybridInput',
        components: {
            DefaultInputField,
        },
        props: {
            placeholder: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                default: 'text',
            },
            value: {
                required: true,
            },
            editable: {
                type: Boolean,
                required: true,
            },
            pattern: {
                type: String,
                default: undefined,
            },
            invalid: {
                type: Boolean,
                required: false,
            },
            title: {
                type: String,
                required: false,
            },
            validator: {
                type: String,
                required: false,
            }
        },
        computed: {
            computedClass() {
                return {
                    editable: this.editable,
                    empty: !this.value,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/bulma/projectBulma.scss";
    @import "@/assets/scss/globals.scss";

    .HybridInput {
        position: relative;
        height: 40px;
        margin: 0;
        transition: 0.1s ease-out height, 0.1s ease-out margin;

        .readonly-value {
            pointer-events: none;
            position: absolute;
            top: 25px;
            right: 0;
            bottom: -10px;
            left: 9px;
            color: $dark-text;
            opacity: 1;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .input-field {
            opacity: 0;
        }

        .readonly-value, .input-field {
            transition: 0.1s ease-out opacity;
        }

        * {
            flex: 1 1;
        }
        
        &.editable {
            height: 56px;
            margin: 7px 0;
            
            .readonly-value {
                opacity: 0;
            }

            .input-field {
                opacity: 1;
            }
        }

        &.empty {
            .readonly-value {
                color: darken($dark-text, 30);
            }
        }
    }
</style>
